// extracted by mini-css-extract-plugin
export default {"infoUserContainer":"style_infoUserContainer__B3END"};